export type PaymentProviderType = 'paddle' | 'polar';

export function getPaymentProvider(): PaymentProviderType {
  const value = ((import.meta.env.VITE_PAYMENT_PROVIDER as string) || 'paddle').trim();
  return value as PaymentProviderType;
}

export function isPolar(): boolean {
  return getPaymentProvider() === 'polar';
}

export function isPaddle(): boolean {
  return getPaymentProvider() === 'paddle';
}

export function getProviderDisplayName(): string {
  return isPolar() ? 'Polar' : 'Paddle';
}
